import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Organizacion } from "@/shared/types/organizacion";

export interface OrganizacionesQuery extends BaseQuery {
    nombre?: string,
}

export async function getAllOrganizaciones(query?: OrganizacionesQuery): Promise<QueryResponse<Organizacion>> {
    await sleep(1000);
    const response = await api.get("organizaciones", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllOrganizacionesQuery(query: OrganizacionesQuery = {}, queryConfig: QueryConfig<QueryResponse<Organizacion>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllOrganizaciones(query),
        queryKey: ["organizaciones", query],
    })
}

export interface GetAllOrganizacionQueryProps {
    query?: OrganizacionesQuery,
    queryConfig?: QueryConfig<QueryResponse<Organizacion>>,
    children: (queryResult: QueryResult<QueryResponse<Organizacion>>) => ReactNode
}

export function GetAllOrganizacionesQuery({
    query,
    queryConfig,
    children
}: GetAllOrganizacionQueryProps) {
    const queryResult = useGetAllOrganizacionesQuery(query, queryConfig);
    return children && children(queryResult);
}